import { supabase } from '../../../lib/supabaseClient';

const BUCKET = 'task-attachments';

export interface TaskAttachment {
  name: string;
  url: string;
  size: string;
  path: string;
}

function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)}KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
}

/**
 * Upload files to Supabase Storage under the task-attachments bucket.
 * Path: {organizationId}/{taskId}/{timestamp}_{filename}
 */
export async function uploadTaskAttachments(
  files: File[],
  taskId: string,
  organizationId: string,
): Promise<TaskAttachment[]> {
  const results: TaskAttachment[] = [];

  for (const file of files) {
    const sanitizedName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
    const path = `${organizationId}/${taskId}/${Date.now()}_${sanitizedName}`;

    const { error } = await supabase.storage
      .from(BUCKET)
      .upload(path, file, {
        cacheControl: '3600',
        upsert: false,
      });

    if (error) {
      console.error('[taskAttachmentService] Upload failed:', error);
      throw new Error(`Falha ao enviar ${file.name}: ${error.message}`);
    }

    const { data: urlData } = supabase.storage
      .from(BUCKET)
      .getPublicUrl(path);

    results.push({
      name: file.name,
      url: urlData.publicUrl,
      size: formatFileSize(file.size),
      path,
    });
  }

  return results;
}
